'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var classNames = require('classnames');
var index$1 = require('../Button/index.js');
var index = require('../DynamicCarousel/index.js');
var index$2 = require('../Icon/index.js');
var BrandFandomLogomark = require('../../assets/BrandFandomLogomark');
var BrandMetacriticLogo = require('../../assets/BrandMetacriticLogo');
var BrandGamespotLogoLight = require('../../assets/BrandGamespotLogoLight');
var BrandGamespotLogoDark = require('../../assets/BrandGamespotLogoDark');
var BrandGamefaqsLogoLight = require('../../assets/BrandGamefaqsLogoLight');
var BrandGamefaqsLogoDark = require('../../assets/BrandGamefaqsLogoDark');
require('../../_virtual/tslib.es6-c0cde917.js');
require('react-alice-carousel');
require('../../icons/IconMenuControlTiny');
require('../../_virtual/useOnLoadImages-c3947139.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var BrandFandomLogomark__default = /*#__PURE__*/_interopDefaultLegacy(BrandFandomLogomark);
var BrandMetacriticLogo__default = /*#__PURE__*/_interopDefaultLegacy(BrandMetacriticLogo);
var BrandGamespotLogoLight__default = /*#__PURE__*/_interopDefaultLegacy(BrandGamespotLogoLight);
var BrandGamespotLogoDark__default = /*#__PURE__*/_interopDefaultLegacy(BrandGamespotLogoDark);
var BrandGamefaqsLogoLight__default = /*#__PURE__*/_interopDefaultLegacy(BrandGamefaqsLogoLight);
var BrandGamefaqsLogoDark__default = /*#__PURE__*/_interopDefaultLegacy(BrandGamefaqsLogoDark);

const WidgetFrame = ({ ctaButtonLink, ctaButtonText = 'View all', hasCarousel, hasToggleButton, headingType = 'h2', initialToggledHeight = 349, isMobile, items, logo = 'fandom', title, onCTAButtonClick, onLeftArrowClick, onRightArrowClick, translations, shouldOpenLinkInNewTab, }) => {
    const [isExpanded, setIsExpanded] = React.useState(false);
    const contentRef = React.useRef(null);
    const target = shouldOpenLinkInNewTab ? '_blank' : '_self';
    const rel = shouldOpenLinkInNewTab ? 'noopener noreferrer' : '';
    const { expandText = 'See more', collapseText = 'See less' } = translations || {};
    const Heading = headingType;
    const isButtonLinkExternal = !(ctaButtonLink === null || ctaButtonLink === void 0 ? void 0 : ctaButtonLink.includes('fandom.com'));
    React.useEffect(() => {
        const setWidgetHeight = () => {
            if (contentRef.current) {
                contentRef.current.style.setProperty('--widget-height', `${contentRef.current.scrollHeight}px`);
            }
        };
        setWidgetHeight();
    }, [isExpanded]);
    const renderLogo = () => {
        switch (logo) {
            case 'metacritic':
                return React__default["default"].createElement(BrandMetacriticLogo__default["default"], null);
            case 'gamespot-light':
                return React__default["default"].createElement(BrandGamespotLogoLight__default["default"], null);
            case 'gamespot-dark':
                return React__default["default"].createElement(BrandGamespotLogoDark__default["default"], null);
            case 'gamefaqs-light':
                return React__default["default"].createElement(BrandGamefaqsLogoLight__default["default"], null);
            case 'gamefaqs-dark':
                return React__default["default"].createElement(BrandGamefaqsLogoDark__default["default"], null);
            default:
                return React__default["default"].createElement(BrandFandomLogomark__default["default"], null);
        }
    };
    const renderStyles = () => {
        if (hasToggleButton) {
            return { height: isExpanded ? 'var(--widget-height)' : initialToggledHeight };
        }
        return undefined;
    };
    const expandButtonClasses = classNames__default["default"]('widget-frame__toggle', {
        'widget-frame__toggle--expanded': isExpanded,
    });
    const widgetFrameClass = classNames__default["default"]('widget-frame', {
        'widget-frame--mobile': isMobile,
    });
    const widgetFrameContentClass = classNames__default["default"]('widget-frame__content', {
        'widget-frame__content--expandable': hasToggleButton,
        'widget-frame__content--expanded': isExpanded,
    });
    return (React__default["default"].createElement("div", { className: widgetFrameClass },
        React__default["default"].createElement("div", { className: "widget-frame__header" },
            React__default["default"].createElement(Heading, { className: "widget-frame__title" }, title),
            React__default["default"].createElement("div", { className: "widget-frame__logo" }, renderLogo())),
        React__default["default"].createElement("div", { ref: contentRef, className: widgetFrameContentClass, style: renderStyles() }, hasCarousel ? (React__default["default"].createElement(index, { items: items, onLeftArrowClick: onLeftArrowClick, onRightArrowClick: onRightArrowClick })) : (items)),
        hasToggleButton && (React__default["default"].createElement(index$1, { onClick: () => setIsExpanded((prevState) => !prevState), "aria-expanded": isExpanded, className: expandButtonClasses, text: true },
            isExpanded ? collapseText : expandText,
            React__default["default"].createElement(index$2, { name: "menu-control", tiny: true }))),
        ctaButtonLink && (React__default["default"].createElement(index$1, { className: "widget-frame__cta", secondary: true, href: ctaButtonLink, target: target, rel: rel, onClick: onCTAButtonClick },
            React__default["default"].createElement("span", { className: "widget-frame__cta-text" }, ctaButtonText),
            isButtonLinkExternal && React__default["default"].createElement(index$2, { className: "widget-frame__cta-icon", name: "external", tiny: true })))));
};
const WidgetFrameSliderItem = ({ children }) => {
    return React__default["default"].createElement("div", { className: "slider-item" }, children);
};

exports.WidgetFrameSliderItem = WidgetFrameSliderItem;
exports["default"] = WidgetFrame;
